import { Action } from "@ngrx/store";

export enum FloorPlannerActionTypes {
  GET_PROJECT_LIST = "[Floorplanner] Get Project List",
  GET_PROJECT_LIST_SUCCESS = "[Floorplanner] Get Project List Success",
  GET_PROJECT_LIST_FAILURE = "[Floorplanner] Get Project List Error",
  CLEAR_PROJECT_LIST = "[Floorplanner] Clear Project List",

  GET_TEMPLATE_LIST = "[Floorplanner] Get Template List",
  GET_TEMPLATE_LIST_SUCCESS = "[Floorplanner] Get Template List Success",
  GET_TEMPLATE_LIST_FAILURE = "[Floorplanner] Get Template List Error",
  CLEAR_TEMPLATE_LIST = "[Floorplanner] Clear Template List",

  GET_TEMPLATE = "[Floorplanner] Get Template",
  GET_TEMPLATE_SUCCESS = "[Floorplanner] Get Template Success",
  GET_TEMPLATE_FAILURE = "[Floorplanner] Get Template Error",

  CREATE_PROJECT = "[Floorplanner] Create Single Project",
  CREATE_PROJECT_SUCCESS = "[Floorplanner] Create Single Project Success",
  CREATE_PROJECT_FAILURE = "[Floorplanner] Create Single Project Failure",

  GET_PROJECT = "[Floorplanner] Get Single Project",
  GET_PROJECT_SUCCESS = "[Floorplanner] Get Single Project Success",
  GET_PROJECT_FAILURE = "[Floorplanner] Get Single Project Failure",

  CREATE_DESIGN = "[Floorplanner] Create Design",
  CREATE_DESIGN_SUCCESS = "[Floorplanner] Create Design Success",
  CREATE_DESIGN_FAILURE = "[Floorplanner] Create Design Failure",

  GET_DESIGN = "[Floorplanner] Create Design",
  GET_DESIGN_SUCCESS = "[Floorplanner] Create Design Success",
  GET_DESIGN_FAILURE = "[Floorplanner] Create Design Failure",

  GET_PRODUCTS = "[Floorplanner] Get Floorplanner Products",
  GET_PRODUCTS_SUCCESS = "[Floorplanner] Get Floorplanner Products Success",
  GET_PRODUCTS_FAILURE = "[Floorplanner] Get Floorplanner Products Failure",
  
  SAVE_PROJECT_PRODUCTS = "[Floorplanner] Save Floorplanner Project Products",
  SAVE_PROJECT_PRODUCTS_SUCCESS = "[Floorplanner] Save Floorplanner Project Products Success",
  SAVE_PROJECT_PRODUCTS_FAILURE = "[Floorplanner] Save Floorplanner Project Products Failure",

  PROJECT_DOWNLOAD = "[Floorplanner] Download Project",
  PROJECT_DOWNLOAD_SUCCESS = "[Floorplanner] Download Project Success",
  PROJECT_DOWNLOAD_FAILURE = "[Floorplanner] Download Project Error",

  PROJECT_EXPORT = "[Floorplanner] Project Export",
  PROJECT_EXPORT_SUCCESS = "[Floorplanner] Project Export Success",
  PROJECT_EXPORT_FAILURE = "[Floorplanner] Project Export Error",

  EXPORT_FML = "[Floorplanner] Export FML",
  EXPORT_FML_SUCCESS = "[Floorplanner] Export FML Success",
  EXPORT_FML_FAILURE = "[Floorplanner] Export FML Error",

  EXPORT_TWO_D = "[Floorplanner] Export 2D",
  EXPORT_TWO_D_SUCCESS = "[Floorplanner] Export 2D Success",
  EXPORT_TWO_D_FAILURE = "[Floorplanner] Export 2D Error",

  EXPORT_THREE_D = "[Floorplanner] Export 3D",
  EXPORT_THREE_D_SUCCESS = "[Floorplanner] Export 3D Success",
  EXPORT_THREE_D_FAILURE = "[Floorplanner] Export 3D Error",

  GET_USER_KEY = "[Floorplanner] Get User Key",
  GET_USER_KEY_SUCCESS = "[Floorplanner] Get User Key Success",
  GET_USER_KEY_FAILURE = "[Floorplanner] Get User Key Failure",
}

export class GetProjectList implements Action {
  readonly type = FloorPlannerActionTypes.GET_PROJECT_LIST;
  constructor() { }
}

export class GetProjectListSuccess implements Action {
  readonly type = FloorPlannerActionTypes.GET_PROJECT_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetProjectListFailure implements Action {
  readonly type = FloorPlannerActionTypes.GET_PROJECT_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class ClearProjectList implements Action {
  readonly type = FloorPlannerActionTypes.CLEAR_PROJECT_LIST;
  constructor() { }
}

export class GetTemplateList implements Action {
  readonly type = FloorPlannerActionTypes.GET_TEMPLATE_LIST;
  constructor() { }
}

export class GetTemplateListSuccess implements Action {
  readonly type = FloorPlannerActionTypes.GET_TEMPLATE_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetTemplateListFailure implements Action {
  readonly type = FloorPlannerActionTypes.GET_TEMPLATE_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class ClearTemplateList implements Action {
  readonly type = FloorPlannerActionTypes.CLEAR_TEMPLATE_LIST;
  constructor() { }
}

export class GetTemplate implements Action {
  readonly type = FloorPlannerActionTypes.GET_TEMPLATE;
  constructor(public id: any) { }
}

export class GetTemplateSuccess implements Action {
  readonly type = FloorPlannerActionTypes.GET_TEMPLATE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetTemplateFailure implements Action {
  readonly type = FloorPlannerActionTypes.GET_TEMPLATE_FAILURE;
  constructor(public payload: any) { }
}

export class ProjectDownload implements Action {
  readonly type = FloorPlannerActionTypes.PROJECT_DOWNLOAD;
  constructor(public id: any) { }
}

export class ProjectDownloadSuccess implements Action {
  readonly type = FloorPlannerActionTypes.PROJECT_DOWNLOAD_SUCCESS;
  constructor(public payload: any) { }
}

export class ProjectDownloadFailure implements Action {
  readonly type = FloorPlannerActionTypes.PROJECT_DOWNLOAD_FAILURE;
  constructor(public payload: any) { }
}

export class ProjectExport implements Action {
  readonly type = FloorPlannerActionTypes.PROJECT_EXPORT;
  constructor(public id: any) { }
}

export class ProjectExportSuccess implements Action {
  readonly type = FloorPlannerActionTypes.PROJECT_EXPORT_SUCCESS;
  constructor(public payload: any) { }
}

export class ProjectExportFailure implements Action {
  readonly type = FloorPlannerActionTypes.PROJECT_EXPORT_FAILURE;
  constructor(public payload: any) { }
}

export class ExportFml implements Action {
  readonly type = FloorPlannerActionTypes.EXPORT_FML;
  constructor(public payload: any) { }
}

export class ExportFmlSuccess implements Action {
  readonly type = FloorPlannerActionTypes.EXPORT_FML_SUCCESS;
  constructor(public payload: any) { }
}

export class ExportFmlFailure implements Action {
  readonly type = FloorPlannerActionTypes.EXPORT_FML_FAILURE;
  constructor(public payload: any) { }
}

export class ExportTwoD implements Action {
  readonly type = FloorPlannerActionTypes.EXPORT_TWO_D;
  constructor(public payload: any) { }
}

export class ExportTwoDSuccess implements Action {
  readonly type = FloorPlannerActionTypes.EXPORT_TWO_D_SUCCESS;
  constructor(public payload: any) { }
}

export class ExportTwoDFailure implements Action {
  readonly type = FloorPlannerActionTypes.EXPORT_TWO_D_FAILURE;
  constructor(public payload: any) { }
}

export class ExportThreeD implements Action {
  readonly type = FloorPlannerActionTypes.EXPORT_THREE_D;
  constructor(public payload: any) { }
}

export class ExportThreeDSuccess implements Action {
  readonly type = FloorPlannerActionTypes.EXPORT_THREE_D_SUCCESS;
  constructor(public payload: any) { }
}

export class ExportThreeDFailure implements Action {
  readonly type = FloorPlannerActionTypes.EXPORT_THREE_D_FAILURE;
  constructor(public payload: any) { }
}

export class CreateProject implements Action {
  readonly type = FloorPlannerActionTypes.CREATE_PROJECT;
  constructor(public payload: any) { }
}

export class CreateProjectSuccess implements Action {
  readonly type = FloorPlannerActionTypes.CREATE_PROJECT_SUCCESS;
  constructor(public payload: any) { }
}

export class CreateProjectFailure implements Action {
  readonly type = FloorPlannerActionTypes.CREATE_PROJECT_FAILURE;
  constructor(public payload: any) { }
}

export class GetProject implements Action {
  readonly type = FloorPlannerActionTypes.GET_PROJECT;
  constructor(public projectId: any) { }
}

export class GetProjectSuccess implements Action {
  readonly type = FloorPlannerActionTypes.GET_PROJECT_SUCCESS;
  constructor(public payload: any) { }
}

export class GetProjectFailure implements Action {
  readonly type = FloorPlannerActionTypes.GET_PROJECT_FAILURE;
  constructor(public payload: any) { }
}

export class CreateDesign implements Action {
  readonly type = FloorPlannerActionTypes.CREATE_DESIGN;
  constructor(public payload: any) { }
}

export class CreateDesignSuccess implements Action {
  readonly type = FloorPlannerActionTypes.CREATE_DESIGN_SUCCESS;
  constructor(public payload: any) { }
}

export class CreateDesignFailure implements Action {
  readonly type = FloorPlannerActionTypes.CREATE_DESIGN_FAILURE;
  constructor(public payload: any) { }
}

export class GetDesign implements Action {
  readonly type = FloorPlannerActionTypes.GET_DESIGN;
  constructor(public payload: any) { }
}

export class GetDesignSuccess implements Action {
  readonly type = FloorPlannerActionTypes.GET_DESIGN_SUCCESS;
  constructor(public payload: any) { }
}

export class GetDesignFailure implements Action {
  readonly type = FloorPlannerActionTypes.GET_DESIGN_FAILURE;
  constructor(public payload: any) { }
}

export class GetProductsList implements Action {
  readonly type = FloorPlannerActionTypes.GET_PRODUCTS;
  constructor(public projectId: any) { }
}

export class GetProductsListSuccess implements Action {
  readonly type = FloorPlannerActionTypes.GET_PRODUCTS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetProductsListFailure implements Action {
  readonly type = FloorPlannerActionTypes.GET_PRODUCTS_FAILURE;
  constructor(public payload: any) { }
}

export class SaveProjectProducts implements Action {
  readonly type = FloorPlannerActionTypes.SAVE_PROJECT_PRODUCTS;
  constructor(public projectId: any) { }
}

export class SaveProjectProductsSuccess implements Action {
  readonly type = FloorPlannerActionTypes.SAVE_PROJECT_PRODUCTS_SUCCESS;
  constructor(public payload: any) { }
}

export class SaveProjectProductsFailure implements Action {
  readonly type = FloorPlannerActionTypes.SAVE_PROJECT_PRODUCTS_FAILURE;
  constructor(public payload: any) { }
}

export class GetUserKey implements Action {
  readonly type = FloorPlannerActionTypes.GET_USER_KEY;
  constructor(public userId: any) { }
}

export class GetUserKeySuccess implements Action {
  readonly type = FloorPlannerActionTypes.GET_USER_KEY_SUCCESS;
  constructor(public payload: any) { }
}

export class GetUserKeyFailure implements Action {
  readonly type = FloorPlannerActionTypes.GET_USER_KEY_FAILURE;
  constructor(public payload: any) { }
}

export type FloorPlannerActions =
  | GetProjectList
  | GetProjectListSuccess
  | GetProjectListFailure
  | ClearProjectList
  | GetTemplateList
  | GetTemplateListSuccess
  | GetTemplateListFailure
  | ClearTemplateList
  | GetTemplate
  | GetTemplateSuccess
  | GetTemplateFailure
  | ProjectDownload
  | ProjectDownloadSuccess
  | ProjectDownloadFailure
  | ProjectExport
  | ProjectExportSuccess
  | ProjectExportFailure
  | ExportFml
  | ExportFmlSuccess
  | ExportFmlFailure
  | ExportTwoD
  | ExportTwoDSuccess
  | ExportTwoDFailure
  | ExportThreeD
  | ExportThreeDSuccess
  | ExportThreeDFailure
  | CreateProject
  | CreateProjectSuccess
  | CreateProjectFailure
  | GetProject
  | GetProjectSuccess
  | GetProjectFailure
  | CreateDesign
  | CreateDesignSuccess
  | CreateDesignFailure
  | GetDesign
  | GetDesignSuccess
  | GetDesignFailure
  | GetProductsList
  | GetProductsListSuccess
  | GetProductsListFailure
  | SaveProjectProducts
  | SaveProjectProductsSuccess
  | SaveProjectProductsFailure
  | GetUserKey
  | GetUserKeySuccess
  | GetUserKeyFailure;
